/*----------------------------------------------------------------------------*\
    Accordeon
    Simple, accesible accordeon
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */



/*  Component
\*----------------------------------------------------------------------------*/

oy.accordeon = {
    init: function(){
        if (oy.cutsMustard) {
            // Your javascript
            this.initAccordeons(document);
        }
    },

    initAccordeons: function ($context) {
        var self = this;
        var $elements = $context.querySelectorAll('.js--accordeon:not(.is-initialised)');

        for (var i = 0; i < $elements.length; ++i) {
            var $element = $elements[i];
            self.setupAccordeon($element);
        }
    },

    setupAccordeon: function ($accordeon) {
        var self = this;
        if(!$accordeon.classList.contains('is-initialised')) {
            self.setupToggles($accordeon);
            $accordeon.classList.add('is-initialised');
        }
    },

    setupToggles: function ($accordeon) {
        var self = this;
        var $toggles = $accordeon.querySelectorAll('.js--accordeon__toggle');

        for (var i = 0; i < $toggles.length; ++i) {
            var $toggle = $toggles[i];
            self.initToggle($accordeon, $toggle);
        }
    },

    initToggle: function ($accordeon, $toggle) {
        var id = $toggle.getAttribute('href');
        var $content = $accordeon.querySelector('.js--accordeon__content' + id);
        var $item = $toggle.closest('.js--accordeon__item');

        if ($item.classList.contains('is-open')) {
            $content.setAttribute('aria-hidden', false);
            $toggle.setAttribute('aria-selected', true);
        } else {
            $content.setAttribute('aria-hidden', true);
            $toggle.setAttribute('aria-selected', false);
        }

        $toggle.addEventListener('click', function (event) {
            event.preventDefault();
            var $this = this;
            if ($item.classList.contains('is-open')) {
                $item.classList.remove('is-open');
                $content.setAttribute('aria-hidden', true);
                $this.setAttribute('aria-selected', false);
            } else {
                $item.classList.add('is-open');
                $content.setAttribute('aria-hidden', false);
                $this.setAttribute('aria-selected', true);
            }

            /**
             * If the page is embedded, update the height
             */
            window.dispatchEvent(oy.settings.embedHeightChange);
        });
    }
};


window.addEventListener('load', function () {
    oy.accordeon.init();
}, false);